/* @flow */

import { combineReducers } from 'redux';

import manualAvailabilityReducer from './manualAvailabilityReducer';

// $FlowIssue
export default combineReducers({
  manual: manualAvailabilityReducer,
});
